import { IContactSettingsPayload, IContactEmailPayload } from 'types/contactSettings.types';
import * as constants from '../constants/contactSettings.constants';

export const onGetContactSettings = () => ({
  type: constants.GET_CONTACT_SETTINGS,
});

export const onGetContactSettingsSuccess = (payload: IContactSettingsPayload) => ({
  type: constants.GET_CONTACT_SETTINGS_SUCCESS,
  payload,
});

export const onSaveContactSettings = (payload: IContactSettingsPayload) => ({
  type: constants.SAVE_CONTACT_SETTINGS,
  payload,
});

export const onSaveContactSettingsSuccess = (payload: IContactSettingsPayload) => ({
  type: constants.SAVE_CONTACT_SETTINGS_SUCCESS,
  payload,
});

export const setSettingsLoading = (payload: boolean) => ({
  type: constants.SET_SETTINGS_LOADING,
  payload,
});

export const getContactSettings = () => ({
  type: constants.SETTINGS_ON_GET_CONTACT_REQUESTED,
});

export const saveContactSettings = (formData: IContactSettingsPayload) => ({
  type: constants.SETTINGS_ON_SAVE_CONTACT_REQUESTED,
  formData,
});

export const sendContactEmailRequest = (formData: IContactEmailPayload) => ({
  type: constants.SEND_CONTACT_EMAIL_REQUESTED,
  formData,
});

export const sendContactEmailSuccess = () => ({
  type: constants.SEND_CONTACT_EMAIL_SUCCEEDED,
});

export const sendContactEmailFailure = (error: string) => ({
  type: constants.SEND_CONTACT_EMAIL_FAILED,
  payload: error,
});

export const resetContactStatus = () => ({
  type: constants.RESET_CONTACT_STATUS,
});
